// RBAC Types and Constants

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  CLIENT: 'CLIENT'
};

export const PERMISSIONS = {
  // Account management
  MANAGE_ACCOUNTS: 'manage_accounts',
  SWITCH_ACCOUNTS: 'switch_accounts',
  
  // Social media posts
  CREATE_POSTS: 'create_posts',
  EDIT_POSTS: 'edit_posts',
  DELETE_POSTS: 'delete_posts',
  VIEW_POSTS: 'view_posts',
  
  // Comments/Notes
  CREATE_COMMENTS: 'create_comments',
  EDIT_COMMENTS: 'edit_comments',
  DELETE_COMMENTS: 'delete_comments',
  VIEW_COMMENTS: 'view_comments',
  
  // Notifications
  VIEW_NOTIFICATIONS: 'view_notifications',
  MANAGE_NOTIFICATIONS: 'manage_notifications'
};

export const ROLE_PERMISSIONS = {
  [USER_ROLES.ADMIN]: [
    PERMISSIONS.MANAGE_ACCOUNTS,
    PERMISSIONS.SWITCH_ACCOUNTS,
    PERMISSIONS.CREATE_POSTS,
    PERMISSIONS.EDIT_POSTS,
    PERMISSIONS.DELETE_POSTS,
    PERMISSIONS.VIEW_POSTS,
    PERMISSIONS.CREATE_COMMENTS,
    PERMISSIONS.EDIT_COMMENTS,
    PERMISSIONS.DELETE_COMMENTS,
    PERMISSIONS.VIEW_COMMENTS,
    PERMISSIONS.VIEW_NOTIFICATIONS,
    PERMISSIONS.MANAGE_NOTIFICATIONS
  ],
  [USER_ROLES.CLIENT]: [
    PERMISSIONS.CREATE_POSTS,
    PERMISSIONS.EDIT_POSTS,
    PERMISSIONS.DELETE_POSTS,
    PERMISSIONS.VIEW_POSTS,
    PERMISSIONS.CREATE_COMMENTS,
    PERMISSIONS.EDIT_COMMENTS,
    PERMISSIONS.DELETE_COMMENTS,
    PERMISSIONS.VIEW_COMMENTS,
    PERMISSIONS.VIEW_NOTIFICATIONS
  ]
};

export const AUDIT_ACTIONS = {
  // Account switching
  ENTER_ACCOUNT_SCOPE: 'enter_account_scope',
  EXIT_ACCOUNT_SCOPE: 'exit_account_scope',
  
  // Post operations
  POST_CREATED: 'post_created',
  POST_UPDATED: 'post_updated',
  POST_DELETED: 'post_deleted',
  
  // Comment operations
  COMMENT_CREATED: 'comment_created',
  COMMENT_UPDATED: 'comment_updated',
  COMMENT_DELETED: 'comment_deleted',
  
  // User management
  USER_ROLE_CHANGED: 'user_role_changed',
  USER_ASSIGNED_TO_ACCOUNT: 'user_assigned_to_account',
  ACCOUNT_CREATED: 'account_created',
  
  // Permission denials
  PERMISSION_DENIED: 'permission_denied',
  CROSS_TENANT_ACCESS_ATTEMPT: 'cross_tenant_access_attempt'
};

export const RESOURCE_TYPES = {
  ACCOUNT: 'account',
  POST: 'post',
  COMMENT: 'comment',
  NOTIFICATION: 'notification',
  USER: 'user'
};
